import { Grid, TextField, IconButton, Grow } from '@material-ui/core';
import cx from 'classnames';
import { icon_send, icon_upload_file, icon_chat_error } from 'components/base/images';
import MuiButton from 'components/common/button/MuiButton';
import EscapeConvert from 'components/common/convert/EscapeConvert';
import MuiWrapper from 'components/common/input/MuiWrapper';
import T from 'components/common/text/T';
import { ProjectSocketContext } from 'contexts/ProjectSocketContext';
import { useDidUpdateEffect } from 'lib/utils';
import _ from 'lodash';
import moment from 'moment';
import React, { Fragment, useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { color } from 'styles/utils';
import GTranslateIcon from '@material-ui/icons/GTranslate';
import { UserActions, ProjectActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import ChatFileUploadPopup from 'components/util/ChatFileUploadPopup';
import storage, { keys } from 'lib/storage';
import DropzoneWrapper from 'components/common/dropzone/DropzoneWrapper';
import CircularLoading from 'components/base/loading/CircularLoading';
import CloseIcon from '@material-ui/icons/Close';

// http://localhost:48052/private, http://localhost:48052/project

interface Message {
  id: string;
  message: string;
  transMessage: string;
  language: string;
  active: boolean;
}

interface ProjectChatContainerProps {
  isShowChat: boolean;
}

interface ProjectChatProps {
  isShowChat: boolean;
  chatFileList: any[];
  chatDataCt: any[];
  language: string;
  talkBoxListScrollRef: React.MutableRefObject<HTMLDivElement | null>;
  message: object | any;
  transMessageList: Message[];
  uploadFileList: {
    value: any;
    onChange: (e: any) => void;
    setValue: (value: any) => void;
  };
  notSupportFiles: string[];
  isAskAgain: {
    value: boolean;
    onChange: (e: any) => void;
    setValue: (value: boolean) => void;
  };
  isFilePopup: {
    value: boolean;
    onChange: (e: any) => void;
    setValue: (value: boolean) => void;
  };
  onScrollChat: (e: any) => void;
  onSendMessage: () => void;
  onTranslation: (value: { id: string; message: string }) => void;
  onClickFileUpload: (e: any) => void;
  onClickTransfer: () => void;
  onClickCancel: () => void;
  onAddLocalFiles: (e: any) => void;
  onRetryUploadFile: (data: any) => void;
  onRemoveFailureFile: (data: any) => void;
  onClickChat: () => void;
  isAllImagesLoaded: boolean;
  projectCode: string;
  isPossibleChat: boolean;
  onImagePopup: (imageId: string) => void;
  onLoadImage: () => void;
  keyboard: {
    value: any;
    onChange: (e: any) => void;
    setValue: (value: any) => void;
  };
}

export default function ProjectChat({
  isShowChat,
  chatFileList,
  chatDataCt,
  language,
  talkBoxListScrollRef,
  message,
  transMessageList,
  uploadFileList,
  notSupportFiles,
  isAskAgain,
  isFilePopup,
  onScrollChat,
  onSendMessage,
  onTranslation,
  onClickFileUpload,
  onClickTransfer,
  onClickCancel,
  onAddLocalFiles,
  onRetryUploadFile,
  onRemoveFailureFile,
  onClickChat,
  isAllImagesLoaded,
  projectCode,
  isPossibleChat,
  onImagePopup,
  onLoadImage,
  keyboard,
}: ProjectChatProps) {
  const { userSyncUid } = useShallowAppSelector(state => ({
    userSyncUid: state.user.user?.syncUid,
  }));
  const { t } = useTranslation();
  const [chatConnect, setChatConnect] = useState<boolean>(true); //기본 True로 처음 진입 시, Disconncet 뜨지 않도록
  const [unreadEl, setUnreadEl] = useState<HTMLDivElement | null>(null);
  const talkBoxListScrollBoxRef = useRef<HTMLDivElement | null>(null);
  const [isFirstOpenDisplay, setIsFirstOpenDisplay] = useState(true);

  const {
    isConnect,
    chatResponseStatus,
    lastUnreadMessageId,
    participant = {},
    handleClickConnect,
  } = useContext(ProjectSocketContext);

  useDidUpdateEffect(() => {
    //초기 랜더링 시에, isConnect 인지하지 않도록 변경
    setChatConnect(isConnect);
  }, [isConnect]);

  // // 여기까지읽었습니다 표시
  useDidUpdateEffect(() => {
    if (!lastUnreadMessageId || !talkBoxListScrollRef.current || !unreadEl || !isFirstOpenDisplay)
      return;
    if (unreadEl.offsetTop < 0) {
      talkBoxListScrollRef.current.scrollTop = unreadEl.offsetTop;
      setIsFirstOpenDisplay(false);
    }
  }, [lastUnreadMessageId, talkBoxListScrollRef.current, unreadEl, isFirstOpenDisplay]);

  const handleResetNoRepeat = () => {
    storage.set(keys.user_no_repeat, []);
    setTimeout(() => {
      UserActions.fetch_profile_request();
    }, 100);
  };

  const handleTestReFetch = () => {
    ProjectActions.fetch_project_request(projectCode);
  };

  const hadleClearChat = () => {
    // 개발 테스트 용
    ProjectActions.clear_chat_all_request({ projectCode: projectCode });
  };

  return (
    <Styled.ProjectChat data-component-name="ProjectChat" className="projectChat">
      {isShowChat && (
        <Grow in={isShowChat} timeout="auto" unmountOnExit>
          <div className="projectChat__contents_wrapper">
            {chatConnect === false && (
              <div className="projectChat__talk_box_dim">
                <span>
                  <T>MODAL_RECONNECT</T>
                </span>
                <MuiButton
                  disableElevation
                  variant="contained"
                  color="primary"
                  onClick={handleClickConnect}
                >
                  <T>GLOBAL_RECONNECT</T>
                </MuiButton>
              </div>
            )}
            {isFilePopup.value && (
              <div className="projectChat__file_popup_dim">
                <ChatFileUploadPopup
                  isAskAgain={isAskAgain}
                  notSupportFiles={notSupportFiles}
                  uploadFileList={uploadFileList}
                  onClickTransfer={onClickTransfer}
                  onClickPopupCancel={onClickCancel}
                />
              </div>
            )}
            {/* {!testLinkBtn && (
              <>
                <button onClick={handleTestDisconncet}>disconncet</button>
                <button onClick={hadleClearChat}>chatClear</button>
                <button onClick={handleResetNoRepeat}>reset</button>
                <button onClick={handleTestReFetch}>refetch</button>
              </>
            )} */}
            <Grid container alignItems="center" className="projectChat__title_container">
              <div className="projectChat__title_icon_box">
                <IconButton
                  aria-label="close chat"
                  className="projectChat__close_box"
                  onClick={onClickChat}
                >
                  <CloseIcon className="projectChat__close_btn" />
                </IconButton>
              </div>
            </Grid>
            <DropzoneWrapper
              apiRequest={e => {
                if (!isPossibleChat) return;
                onAddLocalFiles(e);
              }}
              isView={false}
            >
              <div className="projectChat__content_container" ref={talkBoxListScrollBoxRef}>
                <div
                  ref={talkBoxListScrollRef}
                  onScroll={onScrollChat}
                  className="projectChat__talk_box_list"
                >
                  {chatDataCt?.length > 0 &&
                    chatDataCt.map((item: any, index: number) => {
                      const isSelf = userSyncUid === item.sender;
                      const prevItem = index > 0 && chatDataCt[index - 1];
                      const prevDate = moment(prevItem?.sendDate || null).date();
                      const currentDate = moment(item?.sendDate || null).date();
                      const isDiffDate = !!prevDate && !!currentDate && prevDate !== currentDate;
                      const currentTransItem = transMessageList?.find(
                        trans => trans.id === item._id,
                      );
                      const chatImage = !!item.images ? item.images[0] : null;
                      const chatTempImage = !!item.temp?.file ? item?.temp?.thumb : null;
                      const chatImageStatus = !!chatImage ? chatImage?.status : 'msg';
                      // console.log('HDS] chatImageStatus ____ ', chatImageStatus);
                      const chatImageThumb =
                        chatImageStatus === 'success'
                          ? `${process.env.REACT_APP_S3_PUBLIC_URL}${chatImage?.thumb}`
                          : chatImageStatus === 'fail'
                          ? `${chatTempImage}`
                          : chatImageStatus === 'deleted' || chatImageStatus === 'delete'
                          ? null
                          : `${chatImage?.thumb}`;
                      const findImageIdx = Number(
                        chatFileList.findIndex((list: any) => {
                          return list.imageId === chatImage?.imageId;
                        }),
                      );

                      const imageIdx = findImageIdx === -1 ? 0 : findImageIdx;
                      // console.log('HDS] chatImageThumb _____ ', !!chatImageThumb);
                      if (item.eventType === 'message') {
                        return (
                          <Fragment key={index}>
                            {isDiffDate && (
                              <div className="projectChat__alert_box">
                                <div className="projectChat__date_alert">
                                  {language === 'en'
                                    ? moment(prevItem.sendDate)
                                        .locale(language)
                                        .format('MMM. DD. YYYY')
                                    : moment(prevItem.sendDate)
                                        .locale(language)
                                        .format('YYYY. MM. DD')}
                                </div>
                              </div>
                            )}

                            <div
                              className={cx('projectChat__talk_box', {
                                self: isSelf,
                                partner: !isSelf,
                              })}
                            >
                              {!isSelf && (
                                <div
                                  className={cx('projectChat__talk_name', {
                                    sender: isSelf,
                                    receiver: !isSelf,
                                  })}
                                >
                                  {_.find(participant, i => i.syncUid === item.sender)?.name}
                                </div>
                              )}

                              {!!chatImage ? (
                                <>
                                  <div className="projectChat__talk_content_box">
                                    <div className="projectChat__talk_time_box">
                                      <span
                                        className={cx('projectChat__talk_time', {
                                          isUpload: chatImageStatus === 'init',
                                        })}
                                      >
                                        {chatImageStatus === 'success' &&
                                          moment(item.sendDate).format(' HH:mm')}
                                        {chatImageStatus === 'fail' && (
                                          <span className="projectChat__upload_fail">
                                            <img src={icon_chat_error} />
                                            <T>GLOBAL_UPLOAD_FAIL</T>
                                          </span>
                                        )}
                                      </span>
                                    </div>
                                    <div
                                      className="projectChat__image_content"
                                      onClick={() => {
                                        if (chatImageStatus !== 'success') return;
                                        onImagePopup(chatImage?.imageId);
                                      }}
                                    >
                                      {!!chatImageThumb ? (
                                        <>
                                          {chatImageStatus !== 'success' && (
                                            <div className="projectChat__image_content_dim">
                                              {(chatImageStatus !== 'fail' || !!item?.reTry) && (
                                                <CircularLoading />
                                              )}
                                            </div>
                                          )}
                                          <img
                                            className="projectChat__image"
                                            src={chatImageThumb}
                                            onLoad={onLoadImage}
                                          />
                                        </>
                                      ) : (
                                        <div
                                          className={cx('projectChat__deleted_image_box', {
                                            self: isSelf,
                                            partner: !isSelf,
                                          })}
                                        >
                                          <div className="projectChat__deleted_image">
                                            <div className="projectChat__deleted_icon">
                                              <span>!</span>
                                            </div>
                                            <div>
                                              <T>IMAGE_DELETE_MESSAGE</T>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {chatImageStatus === 'fail' && !item?.reTry && (
                                    <div className="projectChat__image_error">
                                      <div className="projectChat__image_error_btn_box">
                                        <div
                                          className="projectChat__image_error_btn retry"
                                          onClick={() => {
                                            onRetryUploadFile(item);
                                          }}
                                        >
                                          <T>GLOBAL_RETRY</T>
                                        </div>
                                        <div
                                          className="projectChat__image_error_btn cancel"
                                          onClick={() => {
                                            onRemoveFailureFile(item);
                                          }}
                                        >
                                          <T>GLOBAL_CANCEL</T>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div className="projectChat__talk_content_box">
                                  <div className="projectChat__talk_time_box">
                                    {!isSelf && (
                                      <button
                                        className={cx('btn-reset projectChat__talk_translation', {
                                          on: currentTransItem?.active,
                                        })}
                                        onClick={() =>
                                          onTranslation({ id: item._id, message: item.message })
                                        }
                                      >
                                        <GTranslateIcon fontSize="inherit" color="inherit" />
                                      </button>
                                    )}
                                    <br />
                                    <span className="projectChat__talk_time">
                                      {moment(item.sendDate).format(' HH:mm')}
                                    </span>
                                  </div>
                                  <div className="projectChat__talk_content">
                                    {currentTransItem?.active ? (
                                      <EscapeConvert
                                        content={currentTransItem?.transMessage || ''}
                                      />
                                    ) : (
                                      <EscapeConvert content={item.message || ''} />
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                            {lastUnreadMessageId === item._id && isAllImagesLoaded && (
                              <div className="projectChat__alert_box" ref={setUnreadEl}>
                                <div className="projectChat__read_alert">
                                  <T>CHAT_READ</T>
                                </div>
                              </div>
                            )}
                          </Fragment>
                        );
                      }
                    })}
                </div>

                <div className="projectChat__input_box_outer">
                  <div className="projectChat__input_box">
                    <div className="projectChat__file_box">
                      {!isPossibleChat ? (
                        <div className="projectChat__file_icon">
                          <div className="projectChat__file_label">
                            <img src={icon_upload_file} />
                          </div>
                        </div>
                      ) : (
                        <IconButton className="projectChat__file_icon">
                          <label htmlFor="chattingImage" className="projectChat__file_label">
                            <img src={icon_upload_file} />

                            <input
                              type="file"
                              id="chattingImage"
                              name="chattingImage"
                              hidden
                              multiple
                              onChange={e => {
                                onClickFileUpload(e);
                                e.target.value = '';
                              }}
                            />
                          </label>
                        </IconButton>
                      )}
                    </div>

                    <MuiWrapper className="projectChat__input">
                      <TextField
                        variant="outlined"
                        fullWidth
                        multiline
                        value={isPossibleChat ? message.value : t('CHAT_NO_PARTICIPATED')}
                        disabled={chatResponseStatus === 500 || !isPossibleChat}
                        onKeyDown={e => {
                          // 기본 ENTER 줄바꿈 막기, SHIFT와 같이 있을 경우에만 줄바꿈 적용
                          if (!keyboard.value.has('SHIFT') && e.key.toUpperCase() === 'ENTER')
                            e.preventDefault();
                          keyboard.onChange({ key: e.key, type: 'keydown' });
                        }}
                        onKeyUp={e => {
                          // value있고 SHIFT안 누르고 ENTER만 눌렀을 경우 submit
                          if (
                            !!(e.target as HTMLInputElement).value &&
                            !keyboard.value.has('SHIFT') &&
                            keyboard.value.has('ENTER')
                          )
                            onSendMessage();
                          keyboard.onChange({ key: e.key, type: 'keyup' });
                        }}
                        onChange={message.onChange}
                      />
                    </MuiWrapper>
                    <MuiButton
                      disableElevation
                      variant="contained"
                      color="primary"
                      className="projectChat__send_btn"
                      disabled={
                        chatResponseStatus === 500 || !isPossibleChat || !message.value?.trim()
                      }
                      onClick={() => {
                        onSendMessage();
                      }}
                    >
                      <img src={icon_send} alt="send" />
                    </MuiButton>
                  </div>
                </div>
              </div>
            </DropzoneWrapper>
          </div>
        </Grow>
      )}
    </Styled.ProjectChat>
  );
}

const Styled = {
  ProjectChat: styled.div`
    z-index: 9999;
    position: absolute;
    top: 50px;
    right: 0;
    .projectChat__contents_wrapper {
      width: 350px;
      height: 640px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 10px;
      background-color: #fff;
      overflow: hidden;
    }
    .projectChat__talk_box_dim {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.5);
      font-size: 14px;
      color: #fff;
      line-height: 1.3;
      text-align: center;
    }
    .projectChat__file_popup_dim {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: transparent;
    }
    .projectChat__title_container {
      height: 30px;
      padding-left: 30px;
      padding-bottom: 20px;
      .projectChat__title_icon_box {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding: 5px;
        .projectChat__close_box {
          padding: 0;
        }
      }
    }
    .projectChat__content_container {
      position: relative;
      padding: 20px 5px 20px 15px;
      height: 610px;
      background-color: white;
    }
    .projectChat__talk_box_list {
      display: flex;
      flex-direction: column-reverse;
      position: relative;
      height: 505px;
      overflow-y: scroll;
      overflow-x: hidden;
      padding: 5px 0px;
    }
    .projectChat__alert_box {
      display: flex;
      margin-top: 20px;
    }
    .projectChat__read_alert,
    .projectChat__date_alert {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      height: 20px;
      padding: 0 15px;
      background-color: ${color.gray_b5};
      border-radius: 10px;
      font-size: 11px;
      color: white;
      font-weight: 300;
      line-height: 0;
    }
    .projectChat__read_alert {
      width: 100%;
    }

    .projectChat__talk_new_user {
      margin-top: 12px;
      text-align: center;
      font-size: 12px;
      & + .projectChat__talk_new_user {
        margin-top: 5px;
      }
    }

    .projectChat__talk_box {
      position: relative;
      font-size: 14px;

      &:not(:last-child) {
        margin-top: 10px;
      }

      .projectChat__talk_translation {
        font-size: 18px;
        color: ${color.gray_b5};
        text-decoration: underline;
        &.on {
          color: ${color.blue};
        }
      }
      .projectChat__talk_time {
        display: inline-block;
        vertical-align: bottom;
        font-size: 10px;
        color: #9194a4;
        font-weight: 300;
        &.isUpload {
          display: none;
        }
        .projectChat__upload_fail {
          display: flex;
          align-items: center;
          column-gap: 5px;
          font-size: 12px;
          color: #444;
          margin-right: 5px;
        }
      }
      .projectChat__talk_name {
        font-size: 12px;
        margin-bottom: 5px;
        font-style: italic;
        &.sender {
          color: ${color.client_color};
        }
        &.receiver {
          color: ${color.designer_color};
        }
        &.admin {
          color: ${color.admin_color};
        }
      }
      .projectChat__talk_content_box {
        display: inline-flex;
        align-items: flex-end;
        flex-wrap: wrap;
      }
      .projectChat__talk_content {
        display: inline-block;
        position: relative;
        max-width: 248px;
        padding: 10px;
        border-radius: 8px;
        font-size: 14px;
        line-height: 1.3;
        text-align: left;
      }
      .projectChat__image_content {
        width: 248px;
        height: auto;
        border-radius: 5px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .projectChat__image_content_dim {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #000;
          opacity: 0.5;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        .projectChat__deleted_image_box {
          width: 100%;
          display: flex;
          &.self {
            justify-content: flex-end;
          }
          &.partner {
            justify-content: flex-start;
          }

          .projectChat__deleted_image {
            padding: 5px 12px;
            border: 1px dashed #e1e1e7;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            column-gap: 10px;
            color: #b5b7c1;
            .projectChat__deleted_icon {
              font-size: 15px;
              font-weight: 700;
              width: 20px;
              height: 20px;
              border-radius: 10px;
              background-color: #b5b7c1;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              text-align: center;
            }
          }
        }
        &:hover {
          cursor: pointer;
        }
        .projectChat__image {
          width: 250px;
          height: auto;
        }
      }

      &.self {
        padding-left: 15px;
        text-align: right;
        .projectChat__talk_content {
          background-color: #dbf0ff;
          border-bottom-right-radius: 0;
        }

        .projectChat__talk_time_box {
          margin-right: 2px;
        }
      }
      &.partner {
        padding-right: 15px;
        .projectChat__talk_content_box {
          flex-direction: row-reverse;
        }
        .projectChat__talk_content {
          position: relative;
          background-color: #eeeeee;
          border-bottom-left-radius: 0;
        }
        .projectChat__talk_time_box {
          margin-left: 2px;
        }
      }
      .projectChat__image_error {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
        .projectChat__image_error_btn_box {
          width: 106px;
          height: 30px;
          background-color: #f9f9fc;
          border-radius: 3px;
          display: flex;
          align-items: center;
          .projectChat__image_error_btn {
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            &:hover {
              cursor: pointer;
            }
            &.retry {
              width: 60px;
              border-right: 1px solid #ccccd4;
              color: #444;
            }
            &.cancel {
              width: 46px;
              color: #f00;
            }
          }
        }
      }
    }
    .projectChat__input_box_outer {
      position: relative;
      width: 100%;
      padding-right: 10px;
      .projectChat__input_box {
        position: relative;
        display: flex;
        align-items: middle;
        justify-content: space-between;

        height: 65px;
        background-color: #fff;
        .projectChat__file_box {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 55px;
          .projectChat__file_icon {
            width: 40px;
            height: 40px;
            padding: 0;
            .projectChat__file_label {
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
        .muiWrapper {
          width: 326px;
          height: 100%;
          .MuiInputBase-root {
            padding: 10px 10px 10px 0px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
          textarea {
            margin-left: 55px;
            padding: 0;
            height: 100% !important;
            overflow-y: auto !important;
          }
        }
        .button {
          width: 54px;
          height: 100%;
          min-width: initial;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          img {
            width: 15px;
          }
        }
      }
    }
  `,
};
